import { View } from './view'

export const AboutYoutube = View
